<template>
    <svg
        height="24px"
        width="24px"
        id="shopping-list"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 22.5 30"
        style="fill: currentColor"
    >
        <g id="Groupe_276" data-name="Groupe 276" transform="translate(5.646)">
            <g id="Groupe_275" data-name="Groupe 275">
                <path
                    id="Tracé_84"
                    data-name="Tracé 84"
                    d="M170.275,1.868h-2.029a2.8,2.8,0,0,0-5.285,0h-2.027A.934.934,0,0,0,160,2.8V6.539a.934.934,0,0,0,.934.934h9.341a.934.934,0,0,0,.934-.934V2.8A.934.934,0,0,0,170.275,1.868Z"
                    transform="translate(-160)"
                />
            </g>
        </g>
        <g id="Groupe_278" data-name="Groupe 278" transform="translate(0 3.736)">
            <g id="Groupe_277" data-name="Groupe 277">
                <path
                    id="Tracé_85"
                    data-name="Tracé 85"
                    d="M84.625,64H82.75v2.814a2.817,2.817,0,0,1-2.812,2.814H70.562a2.817,2.817,0,0,1-2.812-2.814V64H65.875A1.879,1.879,0,0,0,64,65.876V88.388a1.855,1.855,0,0,0,1.875,1.876h18.75A1.855,1.855,0,0,0,86.5,88.388V65.876A1.855,1.855,0,0,0,84.625,64ZM74.976,80.61l-3.75,3.752a.941.941,0,0,1-1.327,0l-1.875-1.876a.938.938,0,0,1,1.326-1.326l1.213,1.212,3.086-3.088a.938.938,0,0,1,1.327,1.326Zm0-7.5-3.75,3.752a.941.941,0,0,1-1.327,0l-1.875-1.876a.938.938,0,0,1,1.326-1.326l1.213,1.212,3.086-3.088a.938.938,0,0,1,1.327,1.326Zm6.836,9.654h-3.75a.938.938,0,0,1,0-1.876h3.75a.938.938,0,0,1,0,1.876Zm0-7.5h-3.75a.938.938,0,0,1,0-1.876h3.75a.938.938,0,0,1,0,1.876Z"
                    transform="translate(-64 -64)"
                />
            </g>
        </g>
    </svg>
</template>

<script lang="ts">
import { defineComponent } from "vue";
export default defineComponent({
    name: "oss-analysis",
});
</script>
